import React from "react";
import Marketing from "../../components/Marketing/Marketing";
import Product from "../../components/Products/Product";

const Home = () => {
  return <div>
    <Marketing />
    <Product />
  </div>;
};

export default Home;
